import { useState, useEffect } from 'react'

import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'

import {
  EuiPage,
  EuiPageSideBar,
  EuiSideNav,
  EuiIcon,
  EuiFieldSearch,
} from '@elastic/eui'

import ConfigService from '../services/config.service'
import TreeService from '../services/tree.service'
import Document from '../components/Document'
import Help from '../components/Help'
import Admin from '../components/Admin'
import Documentation from '../components/Documentation'

function Work() {
  const history = useNavigate()
  const location = useLocation()
  const isDocPage = location.pathname.startsWith('/Documentation')
  const [isSideNavOpenOnMobile, setIsSideNavOpenOnMobile] = useState(false)
  const [selectedItemName, setSelectedItemName] = useState(null)
  const [selectedItemIcon, setSelectedItemIcon] = useState(null)
  const [selectItemId, setSelectedItemId] = useState(0)
  const [defaultItemId, setDefaultItemId] = useState(0)
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)
  const [tree, setTree] = useState({})
  const [searchValue, setSearchValue] = useState('')
  const user = JSON.parse(localStorage.getItem('user'))

  let isSearchValue = false

  const createItem = (documentId, name, data = {}) => {
    return {
      ...data,
      id: documentId,
      name,
      isSelected: selectItemId === documentId,
      onClick: () => {
        if (data.breadcrumbs) {
          setBreadcrumbs(data.breadcrumbs)
        }

        if (
          name != 'Dashboard' &&
          name != 'Aide' &&
          name != 'Documentation' &&
          name != 'Administration' &&
          name != 'Chart' &&
          name != 'Document' &&
          name != 'Tickets' &&
          name != 'Projects' &&
          name != 'Spaces'
        ) {
          history('/Document')
          setSelectedItemId(documentId)
          setSelectedItemName(name)
        } else if (name == 'Dashboard') {
          history('/Dashboard')
          setSelectedItemId(localStorage.getItem('rootId'))
          setSelectedItemName(name)
  	  setBreadcrumbs([])
        } else if (name == 'Aide') {
          history('/Aide')
        } else if (name == 'Documentation') {
          history('/Documentation')
        } else if (name == 'Administration') {
          history('/Administration')
          setSelectedItemName(name)
        } else {
          history('/Document')
          setSelectedItemId(0)
          setSelectedItemName(name)
        }

        if (
          name == 'Services' ||
          name == 'Microsoft' ||
          name == 'Hébergement' ||
          name == 'Réseaux' ||
          name == 'Passerelles' ||
          name == 'Administration'
        ) {
          setSelectedItemIcon(
            '/static/cybervision/img/sideNav/' + name + '.svg',
          )
        } else {
          setSelectedItemIcon(null)
        }

        if (searchValue != '') {
          isSearchValue = !isSearchValue
          setSearchValue('')
        }
      },
    }
  }

  const buildNav = function (filter) {
    var sidenav = []
    let iconNav = '',
      sidenavCopy = [],
      sidenavFiltered = []

    if (searchValue != '') {
      isSearchValue = !isSearchValue
    }
    if (tree.childrens) {
      for (var c1 in tree.childrens) {
        switch (tree.childrens[c1].title) {
          case 'Services':
            iconNav = '/static/cybervision/img/sideNav/Services.svg'
            break

          case 'Microsoft':
            iconNav = '/static/cybervision/img/sideNav/Microsoft.svg'
            break

          case 'Hébergement':
            iconNav = '/static/cybervision/img/sideNav/Hébergement.svg'
            break

          case 'Réseaux':
            iconNav = '/static/cybervision/img/sideNav/Réseaux.svg'
            break

          case 'Passerelles':
            iconNav = '/static/cybervision/img/sideNav/Passerelles.svg'
            break

          default:
            iconNav = '/static/cybervision/img/sideNav/Passerelles.svg'
            break
        }

        if (tree.childrens[c1].childrens) {
          var item1 = []

          sidenav.push(
            createItem(tree.childrens[c1].id, tree.childrens[c1].title, {
              //forceOpen: false,
              items: item1,
              icon: <EuiIcon type={iconNav} />,
              className: 'highlight',
              breadcrumbs: [
                {
                  text: tree.childrens[c1].title,
                  id: tree.childrens[c1].id,
                  id: tree.childrens[c1].id,
                  href: '#',
                  onClick: (e) => {
                    setSelectedItemId(e.target.id)
                    setSelectedItemName(e.target.text)
                  },
                },
              ],
            }),
          )
          for (var c2 in tree.childrens[c1].childrens) {
            if (tree.childrens[c1].childrens[c2].childrens) {
              var item2 = []
              for (var c3 in tree.childrens[c1].childrens[c2].childrens) {
                if (tree.childrens[c1].childrens[c2].childrens[c3].childrens) {
                  var item3 = []
                  for (var c4 in tree.childrens[c1].childrens[c2].childrens[c3]
                    .childrens) {
                    if (
                      filter &&
                      filter.length > 0 &&
                      tree.childrens[c1].childrens[c2].childrens[c3].childrens[
                        c4
                      ].title.indexOf(filter) == -1
                    ) {
                      continue
                    }
                    item3.push(
                      createItem(
                        tree.childrens[c1].childrens[c2].childrens[c3]
                          .childrens[c4].id,
                        tree.childrens[c1].childrens[c2].childrens[c3]
                          .childrens[c4].title,
                        {
                          className: 'highlight',
                          breadcrumbs: [
                            {
                              text: tree.childrens[c1].title,
                              id: tree.childrens[c1].id,
                              href: '#',
                              onClick: (e) => {
                                setSelectedItemId(e.target.id)
                                setSelectedItemName(e.target.text)
                              },
                            },
                            {
                              text: tree.childrens[c1].childrens[c2].title,
                              id: tree.childrens[c1].childrens[c2].id,
                              href: '#',
                              onClick: (e) => {
                                setSelectedItemId(e.target.id)
                                setSelectedItemName(e.target.text)
                              },
                            },
                            {
                              text:
                                tree.childrens[c1].childrens[c2].childrens[c3]
                                  .title,
                              id:
                                tree.childrens[c1].childrens[c2].childrens[c3]
                                  .id,
                              href: '#',
                              onClick: (e) => {
                                setSelectedItemId(e.target.id)
                                setSelectedItemName(e.target.text)
                              },
                            },
                            {
                              text:
                                tree.childrens[c1].childrens[c2].childrens[c3]
                                  .childrens[c4].title,
                              id:
                                tree.childrens[c1].childrens[c2].childrens[c3]
                                  .childrens[c4].id,
                              href: '#',
                              onClick: (e) => {
                                setSelectedItemId(e.target.id)
                                setSelectedItemName(e.target.text)
                              },
                            },
                          ],
                        },
                      ),
                    )
                  }
                  item2.push(
                    createItem(
                      tree.childrens[c1].childrens[c2].childrens[c3].id,
                      tree.childrens[c1].childrens[c2].childrens[c3].title,
                      {
                        items: item3,
                        className: 'highlight',
                        forceOpen: isSearchValue,
                        breadcrumbs: [
                          {
                            text: tree.childrens[c1].title,
                            id: tree.childrens[c1].id,
                            href: '#',
                            onClick: (e) => {
                              setSelectedItemId(e.target.id)
                              setSelectedItemName(e.target.text)
                            },
                          },
                          {
                            text: tree.childrens[c1].childrens[c2].title,
                            id: tree.childrens[c1].childrens[c2].id,
                            href: '#',
                            onClick: (e) => {
                              setSelectedItemId(e.target.id)
                              setSelectedItemName(e.target.text)
                            },
                          },
                          {
                            text:
                              tree.childrens[c1].childrens[c2].childrens[c3]
                                .title,
                            id:
                              tree.childrens[c1].childrens[c2].childrens[c3].id,
                            href: '#',
                            onClick: (e) => {
                              setSelectedItemId(e.target.id)
                              setSelectedItemName(e.target.text)
                            },
                          },
                        ],
                      },
                    ),
                  )
                } else {
                  item2.push(
                    createItem(
                      tree.childrens[c1].childrens[c2].childrens[c3].id,
                      tree.childrens[c1].childrens[c2].childrens[c3].title,
                      {
                        className: 'highlight',
                        breadcrumbs: [
                          {
                            text: tree.childrens[c1].title,
                            id: tree.childrens[c1].id,
                            href: '#',
                            onClick: (e) => {
                              setSelectedItemId(e.target.id)
                              setSelectedItemName(e.target.text)
                            },
                          },
                          {
                            text: tree.childrens[c1].childrens[c2].title,
                            id: tree.childrens[c1].childrens[c2].id,
                            href: '#',
                            onClick: (e) => {
                              setSelectedItemId(e.target.id)
                              setSelectedItemName(e.target.text)
                            },
                          },
                          {
                            text:
                              tree.childrens[c1].childrens[c2].childrens[c3]
                                .title,
                            id:
                              tree.childrens[c1].childrens[c2].childrens[c3].id,
                            href: '#',
                            onClick: (e) => {
                              setSelectedItemId(e.target.id)
                              setSelectedItemName(e.target.text)
                            },
                          },
                        ],
                      },
                    ),
                  )
                }
              }
              item1.push(
                createItem(
                  tree.childrens[c1].childrens[c2].id,
                  tree.childrens[c1].childrens[c2].title,
                  {
                    items: item2,
                    className: 'highlight',
                    forceOpen: isSearchValue,
                    breadcrumbs: [
                      {
                        text: tree.childrens[c1].title,
                        id: tree.childrens[c1].title.id,
                        href: '#',
                        onClick: (e) => {
                          setSelectedItemId(e.target.id)
                          setSelectedItemName(e.target.text)
                        },
                      },
                      {
                        text: tree.childrens[c1].childrens[c2].title,
                        id: tree.childrens[c1].childrens[c2].id,
                        href: '#',
                        onClick: (e) => {
                          setSelectedItemId(e.target.id)
                          setSelectedItemName(e.target.text)
                        },
                      },
                    ],
                  },
                ),
              )
            } else {
              item1.push(
                createItem(
                  tree.childrens[c1].childrens[c2].id,
                  tree.childrens[c1].childrens[c2].title,
                  {
                    className: 'highlight',
                    breadcrumbs: [
                      {
                        text: tree.childrens[c1].title,
                        id: tree.childrens[c1].title.id,
                        href: '#',
                        onClick: (e) => {
                          setSelectedItemId(e.target.id)
                          setSelectedItemName(e.target.text)
                        },
                      },
                      {
                        text: tree.childrens[c1].childrens[c2].title,
                        id: tree.childrens[c1].childrens[c2].id,
                        href: '#',
                        onClick: (e) => {
                          setSelectedItemId(e.target.id)
                          setSelectedItemName(e.target.text)
                        },
                      },
                    ],
                  },
                ),
              )
            }
          }
        } else {
          sidenav.push(
            createItem(tree.childrens[c1].id, tree.childrens[c1].title, {
              icon: <EuiIcon type={iconNav} />,
              className: 'highlight',
              breadcrumbs: [
                {
                  text: tree.childrens[c1].title,
                  id: tree.childrens[c1].title.id,
                  href: '#',
                  onClick: (e) => {
                    setSelectedItemId(e.target.id)
                    setSelectedItemName(e.target.text)
                  },
                },
              ],
            }),
          )
        }
      }
    }

    sidenavCopy = [...sidenav]

    if (searchValue == '') {
      var dynamicNav = createItem('10', '', {
        forceOpen: true,
        items: sidenav,
        className: 'menuDynamique',
      })
    } else {
      sidenavFiltered = onSearch(sidenavCopy, searchValue)

      var dynamicNav = createItem('10', '', {
        forceOpen: true,
        items: sidenavFiltered,
        className: 'menuDynamique',
      })
    }

    var fullnav = []
    fullnav.push(
      createItem('9', 'Dashboard', {
        icon: <EuiIcon type="/static/cybervision/img/sideNav/Dashboard.svg" />,
      }),
    )

    fullnav.push(dynamicNav)

    fullnav.push(
      createItem('1', 'Documentation', {
        icon: <EuiIcon type="/static/cybervision/img/sideNav/Aide.svg" />,
        className: 'beforeLastChild',
      }),
    )


    if (user.role === 'ADMIN') {
      fullnav.push(
        createItem('3', 'Administration', {
          icon: (
            <EuiIcon type="/static/cybervision/img/sideNav/Administration.svg" />
          ),
        }),
      )
    }



    var finalnav = createItem('0', '', {
      forceOpen: true,
      items: fullnav,
      className: 'menuStatic',
    })

    highlightSearch()

    return (
      <EuiSideNav
        aria-label="Cybervision navigation menu"
        mobileTitle="Cybervision"
        toggleOpenOnMobile={toggleOpenOnMobile}
        isOpenOnMobile={isSideNavOpenOnMobile}
        items={[finalnav]}
      />
    )
  }

  const toggleOpenOnMobile = () => {
    setIsSideNavOpenOnMobile(!isSideNavOpenOnMobile)
  }

  function onSearch(array, filterSearch) {
    const getNodes = (result, object) => {
      let find = false

      if (object.name.toLowerCase().indexOf(filterSearch.toLowerCase()) != -1) {
        result.push(object)
      }

      if (Array.isArray(object.items)) {
        const items = object.items.reduce(getNodes, [])
        result.forEach((unObject) => {
          if (unObject.name == object.name) {
            find = true
            unObject.items = items
          }
        })

        if (items.length) {
          if (!find) {
            result.push({ ...object, items })
          }
        }
      }
      return result
    }
    return array.reduce(getNodes, [])
  }

  function highlightSearch() {
    let labelNav, i, highlightValue

    setTimeout(() => {
      const divOfLabelNav = document.getElementsByClassName('highlight')

      for (i = 0; i < divOfLabelNav.length; i++) {
        labelNav = divOfLabelNav[i].firstChild.firstChild.lastChild
        const indexValue = labelNav
          .getAttribute('title')
          .toUpperCase()
          .indexOf(searchValue.toUpperCase())

        if (labelNav.firstChild) {
          labelNav.innerHTML = labelNav.textContent
        }

        if (indexValue != -1 && searchValue != '') {
          if (indexValue == 0) {
            highlightValue =
              "<span class='highlightValue'>" +
              searchValue.charAt(0).toUpperCase() +
              searchValue.slice(1) +
              '</span>'
          } else {
            highlightValue =
              "<span class='highlightValue'>" + searchValue + '</span>'
          }

          labelNav.innerHTML =
            labelNav.innerHTML.substring(0, indexValue) +
            highlightValue +
            labelNav.innerHTML.substring(indexValue + searchValue.length)
        }
      }
    }, 300)
  }

  const rooting = async () =>{
    const root = await ConfigService.getRoot()
    localStorage.setItem('rootId', root.data.id)
    return localStorage
  }

  const getTree = async () => {
     if (isLoaded == false) {
      setIsLoaded(true)
      await rooting();
      const rootId = localStorage.getItem('rootId')
      // Guard : pas d'appel API si rootId pas dispo
      if (!rootId || rootId === '0') {
        return
      }
      TreeService.getTree(rootId)
      .then(function (res) {
        setTree(res.data)
        setDefaultItemId(rootId)
      })
      .catch((err) => {
        console.log('tree', err)
      })
    }

  }

  useEffect( () => {
    getTree()
  }, [isLoaded])

  return user.username ? (
      <EuiPage>
        {tree && !isDocPage ? (
          <EuiPageSideBar>
            <img
              className="euiIcon logoCybervision"
              src="/static/cybervision/img/logo-cybervision-cartouche.svg"
            ></img>

            <EuiFieldSearch
              placeholder="Rechercher"
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
            />
            {buildNav(tree)}
          </EuiPageSideBar>
        ) : (
          <></>
        )}
        <Routes>
          <Route path="/Dashboard"
            element={<Document
              chartsOnly="true"
              breadcrumbs={breadcrumbs}
              kpiCode={defaultItemId}
              selectedItemName={'Dashboard'}
              selectedItemIcon={selectedItemIcon}
            />}
          />
          <Route path="/Document"
            element={<Document
              kpiCode={selectItemId}
              breadcrumbs={breadcrumbs}
              selectedItemName={selectedItemName}
              selectedItemIcon={selectedItemIcon}
            />}
          />
          <Route path="/Aide" element={<Help />} />
          <Route path="/Documentation/*" element={<Documentation />} />
          <Route path="/Administration"
            element={<Admin
              selectedItemName={selectedItemName}
              selectedItemIcon={selectedItemIcon}
            />}
          />
        </Routes>
      </EuiPage>
  ) : (
    <></>
  )
}

export default Work
